var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClosed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6227 0.371009C15.1196 -0.12367 14.3041 -0.12367 13.801 0.371009L5.08622 8.94339L2.199 6.10436C1.69593 5.60968 0.880383 5.60968 0.377307 6.10436C-0.125769 6.59904 -0.125769 7.40097 0.377307 7.89565L4.17381 11.6288C4.5894 12.0374 5.23308 12.1173 5.73928 11.8254C5.75803 11.8131 5.77678 11.8039 5.7924 11.7916C5.86427 11.7455 5.93301 11.6902 5.99551 11.6288L15.6227 2.1623C16.1258 1.66762 16.1258 0.865687 15.6227 0.371009Z",
    fill: "#047857"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosed);
export default __webpack_public_path__ + "static/media/Closed.614ee32161a2295842505c62ed531235.svg";
export { ForwardRef as ReactComponent };